var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIAvnArrow = function SvgIAvnArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.135 6.717H.65",
    stroke: "#0054F7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    "data-no-fill": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.114 2.282 9.65 6.747 5.18 10.782",
    stroke: "#0054F7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-no-fill": "true"
  })));
};
export { SvgIAvnArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNOS4xMzUyOCA2LjcxNzQ5SDAuNjQ5OTk5IiBzdHJva2U9IiMwMDU0RjciIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGRhdGEtbm8tZmlsbD0idHJ1ZSIvPgogICAgPHBhdGggZD0iTTUuMTE0NDcgMi4yODIxTDkuNjQ5NjIgNi43NDY2OEw1LjE4MTEyIDEwLjc4MTgiIHN0cm9rZT0iIzAwNTRGNyIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZGF0YS1uby1maWxsPSJ0cnVlIi8+Cjwvc3ZnPg==";